import { useMutation } from '@tanstack/react-query';
import { postResend2FA } from 'services';
import { useSnackbar } from 'hooks';

const errorMessage = 'Something went wrong, please try again later.';
export interface Resend2FAEmailPayload {
  corpAcctNumber: number;
  businessEmailNew: string | null;
  restartAuthVettingStatus: boolean;
}
export function usePostResend2FAEmail() {
  const setSnackbar = useSnackbar();

  return useMutation({
    mutationFn: (payload: Resend2FAEmailPayload) => postResend2FA(payload),
    onSuccess: () => {
      setSnackbar({
        message: 'Verification email sent.',
        severity: 'success',
      });
    },
    onError: (error) => {
      const errorResponse = error as {
        response?: { data?: { displayMessage?: string } };
      };
      setSnackbar({
        message: errorResponse?.response?.data?.displayMessage || errorMessage,
        severity: 'error',
      });
    },
  });
}
